/**
 * HTTP request layer
 * if auth is required return patched axios instance(with access token in headers)
 * else return clear axios instance
 */

import * as authService from "../services/auth.service";
import axios from "axios";
import { CONFIG } from "../config";
import { ResponseWrapper, ErrorWrapper } from "./util";
import router from "~/router";
import store from "~/store";
import Bugsnag from "@bugsnag/browser";

export default class Http {
  constructor(status) {
    this.isAuth = status && status.auth ? status.auth : false;
    this.instance = axios.create({
      baseURL: CONFIG.API_URL,
    });
    this.instance.interceptors.response.use(
      (response) => response,
      (error) => {
        const { status } = error.response;
        if (status === 401 && store.getters.authCheck) {
          if (authService.isAccessTokenExpired()) {
            return new Promise(function (resolve, reject) {
              resolve(
                authService
                  .refreshTokens()
                  .then((response) => {
                    return axios
                      .request(error.response.config)
                      .then(
                        (response) =>
                          new ResponseWrapper(response, response.data),
                      )
                      .catch((error) => new ErrorWrapper(error));
                  })
                  .catch((err) => {
                    Bugsnag.notify(err);
                    store.dispatch("logout");
                    router.push({ name: "login" });
                    reject(err);
                  }),
              );
            });
          } else if (status === 403) {
            router.push({ name: "AccessDenied" });
          } else {
            store.dispatch("logout");
            router.push({ name: "login" });
          }
        }
        return Promise.reject(error);
      },
    );
    return this.init();
  }

  init() {
    return this.instance;
  }
}
